import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const HeartRateHistoryPage = lazy(() => import("./HeartRateHistoryPage"));

function HeartRateHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeartRateHistoryPage />
    </Suspense>
  );
}

export default HeartRateHistoryPageLazy;
